// composables/useZitadelSignOut.ts
// Clears the local @auth/core session then redirects to Zitadel's end_session endpoint.
// All Zitadel config is read from clientConfig (populated from client.config.yml + .env).

export function useZitadelSignOut() {
  async function signOut(callbackUrl = '/auth/signin') {
    // Step 1: Clear the local @auth/core session cookie
    try {
      const { csrfToken } = await $fetch<{ csrfToken: string }>('/api/auth/csrf');
      await $fetch('/api/auth/signout', {
        method: 'POST',
        body: new URLSearchParams({ csrfToken, callbackUrl, json: 'true' }).toString(),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    } catch {
      // Proceed even if this fails
    }

    // Step 2: Redirect to Zitadel's end_session endpoint to terminate the SSO session.
    // Values come from client.config.yml (which interpolates ${ZITADEL_ISSUER} / ${ZITADEL_CLIENT_ID}).
    // Zitadel requires client_id so it can resolve the registered post_logout_redirect_uri.
    const clientConfig = (useRuntimeConfig().public.clientConfig as any);
    const issuer = clientConfig?.auth?.zitadel?.issuer?.replace(/\/$/, '');
    const clientId = clientConfig?.auth?.zitadel?.clientId;

    if (issuer && clientId) {
      const postLogoutUri = `${window.location.origin}${callbackUrl}`;
      const params = new URLSearchParams({
        client_id: clientId,
        post_logout_redirect_uri: postLogoutUri,
      });
      window.location.href = `${issuer}/oidc/v1/end_session?${params.toString()}`;
    } else {
      // Fallback if Zitadel config isn't available
      window.location.href = callbackUrl;
    }
  }

  return { signOut };
}
